import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {MatChipInputEvent} from '@angular/material/chips';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import { debounceTime, distinctUntilChanged, map, Observable, startWith, switchMap } from 'rxjs';
import { TraceabilityReportService } from 'src/app/modules/harcoded-reports/traceability-report/traceability-report.service';

@Component({
  selector: 'app-chips-autocomplete',
  templateUrl: './chips-autocomplete.component.html',
  styleUrls: ['./chips-autocomplete.component.scss']
})
export class ChipsAutocompleteComponent implements OnInit, OnChanges {

  @Input() label = 'Items';
  @Input() allItems: string[] = [];
  @Input() control!: FormControl;

  separatorKeysCodes = [ENTER, COMMA];
  itemCtrl = new FormControl('');
  filteredItems!: Observable<string[]>;

   @ViewChild('itemInput') itemInput!: ElementRef<HTMLInputElement>;


  constructor(private traceabilityService: TraceabilityReportService) { }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {

    this.filteredItems = this.itemCtrl.valueChanges.pipe(
        startWith(''),
        debounceTime(300),
        distinctUntilChanged(),
        switchMap(value => {
          const filterValue = value || "";
          const param = value && value.trim() !== '' ? { ProcessOrderNo: value } : "";
          return this.traceabilityService.getProcessOrderByNo(param).pipe(
            map((res: any) => {
              this.allItems = res?.data?.ProcessOrderNo || [];
              const current = this.control?.value || [];
               return this.allItems.filter(
              item =>
                item.toLowerCase().includes(filterValue) && !current.includes(item)
              );
            })
          );
        })
    );

  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value && this.control) {
      const current = this.control.value || [];
      if (!current.includes(value)) {
        this.control.setValue([...current, value]);
      }
    }
    event.chipInput!.clear();
    this.itemCtrl.setValue(null);
  }

  remove(item: string): void {
    if (!this.control) return;
    const current = this.control.value || [];
    this.control.setValue(current.filter((i: string) => i !== item));
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.control) return;
    const value = event.option.viewValue;
    const current = this.control.value || [];
    if (!current.includes(value)) {
      this.control.setValue([...current, value]);
    }
    this.itemInput.nativeElement.value = '';
    this.itemCtrl.setValue(null);
  }

  private _filter(value: string | null): string[] {
    if (!this.control) return [];
    const filterValue = (value || '').toLowerCase();
    const current = this.control.value || [];
    return this.allItems.filter(
      item =>
        item.toLowerCase().includes(filterValue) && !current.includes(item)
    );
  }

}
